// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"363":"99a5f3e8bb9617bd","556":"fbbee9c6ec0f4c0a","804":"e962f4dcd3656547"}[chunkId] + ".js";
};